module.exports = __webpack_public_path__ + "static/media/facebook-shadow.9ace7d50.png";